import React from 'react';
import { useNavigate } from 'react-router-dom';

import withRole from 'hoc/withRole';
import Button from 'core/buttons/Button';
import PageContent from 'layouts/PageContent';

import acl from 'app/config/acl';
import { buildRoute } from 'routes';
import WebhookForm from 'components/webhooks/WebhookForm';
import WebhookProgressIndicatorModal from 'components/webhooks/WebhookProgressIndicatorModal';

function AddWebhook() {
  const navigate = useNavigate();

  return (
    <PageContent
      title="Add Webhook"
      rightTopEndContent={
        <Button onClick={() => navigate(buildRoute('webhooks.index'))}>List Webhook</Button>
      }
    >
      <WebhookForm isAddMode={true} />
      <WebhookProgressIndicatorModal isAddMode={true} />
    </PageContent>
  );
}

export default withRole([acl.SUPERADMIN, acl.ADMIN])(AddWebhook);
